import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import { useSelector } from "react-redux"
import CircularProgress from "@material-ui/core/CircularProgress"
import Link from "@material-ui/core/Link"
import { FormSpy } from "react-final-form"

const useStyles = makeStyles((theme) => ({
  show_total: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(1.5),
  },
  separator: {
    height: 10,
    borderRight: "1px solid #00000099",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  loading: {
    marginLeft: theme.spacing(1),
  },
}))

function ShowTotal({ handleFetchList }) {
  const classes = useStyles()
  const fetching = useSelector((state) => state.medicine.fetching)
  const total = useSelector((state) => state.medicine.total)

  return (
    <FormSpy subscription={{ values: true }}>
      {({ form: { reset } }) => (
        <Grid container alignItems="center" className={classes.show_total}>
          <Typography variant="caption">Result {total}</Typography>
          <div className={classes.separator} />
          <Typography
            component={Link}
            color="primary"
            variant="caption"
            onClick={() => {
              reset()
              handleFetchList()
            }}
          >
            Reset
          </Typography>
          {fetching && (
            <CircularProgress size={20} className={classes.loading} />
          )}
        </Grid>
      )}
    </FormSpy>
  )
}

export default ShowTotal
